import { useMutation } from '@apollo/client';
import { OrganisationSettingMap } from './useSettingsVM';
import {
  UPDATE_ORGANISATION_SETTINGS,
  UpdateOrganizationSettingInput,
  UpdateOrganizationSettingResponse,
} from '../../../apollo/queries/organisations/updateOrganisationSetting.queries';
import { SettingsToastHelper } from '../../../components/OrganisationMembers/Settings';
import { SettingCategory, SettingCode } from '../types';
import { ContentRepository } from '../../../apollo/queries/organisations/contentRepositores.queries';

const useUpdateSettings = () => {
  const [updateSettings, { loading }] =
    useMutation<UpdateOrganizationSettingResponse>(
      UPDATE_ORGANISATION_SETTINGS,
      {
        onCompleted: (data: UpdateOrganizationSettingResponse) => {
          if (data.updateSettings) {
            SettingsToastHelper.updateSettingsSuccess();
          }
        },
        onError: (e) => {
          SettingsToastHelper.error();
        },
      },
    );

  const onUpdateSettings = (
    settings: OrganisationSettingMap,
    organization: string,
  ) => {
    const contentManagementSettings =
      settings.get(SettingCategory.contentManagement) || [];

    const getContentRepositories = () => {
      const contentManagement = contentManagementSettings.find(
        (c) => c.settingCode === SettingCode.contentRepository,
      );

      const contentRepositories = contentManagement
        ? (contentManagement.value as ContentRepository[])
        : [];
      return contentRepositories.map(({ id }) => id);
    };

    const schema: UpdateOrganizationSettingInput = {
      organization,
      contentRepositorySettings: getContentRepositories(),
    };

    updateSettings({ variables: { schema } });
  };

  return {
    loading,
    onUpdateSettings,
  };
};

export default useUpdateSettings;
